import { ReactElement } from 'react'
import styled from 'styled-components'
import { colors } from '../../../const/theme'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Small } from '../../../typography'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

export const InfoListWrapper = styled.div`
  display: flex;
  margin: 40px auto;
  width: 85%;
  justify-content: space-evenly;
  flex-wrap: wrap;
  height: auto;
`

const Info = styled.div`
  display: flex;
  align-items: center;
  width: 220px;
  height: 80px;
  background: ${colors.lavenderBlush};
  border-radius: 10px;
  justify-content: space-evenly;
  margin-top: 12px;
  box-shadow: 0 1px 2px 0 ${({ theme }) => theme.card.border};
`
interface InfoWrapperProps {
  icon: IconProp
  info: string
  suffix: string
}

export const InfoWrapper = ({
  icon,
  info,
  suffix
}: InfoWrapperProps): ReactElement => {
  return (
    <Info>
      <FontAwesomeIcon icon={icon} size="lg" />
      <Small>{info}</Small>
      <Small color={colors.purple}>{suffix}</Small>
    </Info>
  )
}

export const NotesWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  margin-bottom: 20px;
`

export const Notes = styled.div`
  width: 85%;
  margin: 16px auto;
  background: ${colors.lavenderBlush};
  border-radius: 10px;
  text-align: left;
  padding: 20px;
  box-shadow: 0 1px 2px 0 ${({ theme }) => theme.card.border};
  > * {
    padding: 8px;
  }
`
